{
    "MaxPartitions": "Apenas serão verificadas as primeiras {} partições quanto a dispositivos; ative os \"Relatórios para toda a telefonia\" (Telephony-Wide Reporting) nas definições do Telsys para verificar todas as partições.",
    "NAME": "ErrorLanguage",
    "Error_Title": "Desculpe",
    "Error_SubTitle": "Não conseguimos encontrar a página que está procurando.",
    "Error_Message": "A página ou recurso pode ter sido movido, atualizado ou removido. \n \n Ou pode ter digitado o endereço da web incorretamente. Verifique o endereço e a ortografia.",
    "Error_PageTitle": "Desculpe, não conseguimos encontrar a página que está procurando.",
    "Validations_MustBeUnique": "O valor deve ser único"
}